module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_06_770_280_th-f485d6f35bb1d4895c0cf7155f519a52.jpg";